import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Icon from "../../HOC/Icon";
import { SwipeableDrawer } from "@mui/material";
import SM from "../../DIsplay/Screen/SM";
import { ModifyHotelBookingModal } from "../../modal/modifyHotelBookingModal/ModifyHotelBookingModal";
import { CancelAccommodationBookingModal } from "../../modal/CancelAccommodationBookingModal";
import { AccommodationOrderPriceDetailModal } from "../../modal/AccommodationOrderPriceDetailModal";
import { AccommodationOrderDetailsModal } from "../../modal/accommodationDetails/AccommodationOrderDetailsModal";
import { configurations } from "../../../configurations";
import { TourOrderDetailModal } from "../../modal/tourOrderDetails/TourOrderDetailModal";
import { CancelInsuranceBookingModal } from "../../modal/CancelInsuranceBookingModal";
import { InsuranceOrderDetailsModal } from "../../modal/insuranceOrderDetails/InsuranceOrderDetailsModal";
import FlightMenu from "./FlightMenu";
import StayMenu from "./StayMenu";
import TourMenu from "./TourMenu";
import InsuranceMenu from "./InsuranceMenu";
import { CancelPendingAccommodationBookingModal } from "../../modal/CancelPendingAccommodationBookingModal";
import { CancelPendingTourBookingModal } from "../../modal/CancelPendingTourBookingModal";
import { CancelPendingInsuranceBookingModal } from "../../modal/CancelPendingInsuranceBookingModal";
import { PayAccommodationBookingModal } from "../../modal/PayAccommodationBookingModal";
import { PayTourBookingModal } from "../../modal/PayTourBookingModal";
import { PayInsuranceBookingModal } from "../../modal/PayInsuranceBookingModal";
import { UpdateFareAccommodationBookingModal } from "../../modal/UpdateFareAccommodationBookingModal";
import { UpdateFareInsuranceBookingModal } from "../../modal/UpdateFareInsuranceBookingModal";
import { ConfirmInsuranceIssuanceModal } from "../../modal/ConfirmInsuranceIssuanceModal";
import { RebookInsuranceBookingModal } from "../../modal/RebookInsuranceBookingModal";
import { UpdateFareTourBookingModal } from "../../modal/UpdateFareTourBookingModal";
import { CancelAccommodationAwaitingBookingModal } from "../../modal/CancelAccommodationAwaitingBookingModal";
import PackageMenu from "./PackageMenu";
import CancelPackageModal from "../../modal/CancelPackageModal";
import { PayPackageBookingModal } from "../../modal/PayPackageBookingModal";
import { PackageOrderDetailsModal } from "../../modal/packageDetail/PackageOrderDetailsModal";
import EsimMenu from "./EsimMenu";
import CancelEsimBookingModal from "../../modal/CancelEsimBookingModal";
import EsimOrderDetailsModal from "../../modal/EsimOrderDetailsModal";

const OrderMenu = ({ order, og, reload }) => {
  const [open, setOpen] = useState(false);
  const [viewHotelOrder, setViewHotelOrder] = useState(false);
  const [modifyHotelOrder, setModifyHotelOrder] = useState(false);
  const [cancelHotelAwaitingBooking, setCancelHotelAwaitingBooking] =
    useState(false);
  const [cancelHotelOrder, setCancelHotelOrder] = useState(false);
  const [cancelPendingHotelOrder, setCancelPendingHotelOrder] = useState(false);
  const [payHotelOrder, setPayHotelOrder] = useState(false);
  const [hotelPriceDetailModal, setHotelPriceDetailModal] = useState(false);
  const [viewTourOrder, setViewTourOrder] = useState(false);
  const [cancelPendingTourOrder, setCancelPendingTourOrder] = useState(false);
  const [payTourOrder, setPayTourOrder] = useState(false);
  const [viewInsuranceOrder, setViewInsuranceOrder] = useState(false);
  const [cancelInsuranceOrder, setCancelInsuranceOrder] = useState(false);
  const [cancelPendingInsuranceOrder, setCancelPendingInsuranceOrder] =
    useState(false);
  const [payInsuranceOrder, setPayInsuranceOrder] = useState(false);
  const [updateFareHotelOrder, setUpdateFareHotelOrder] = useState(false);
  const [updateFareTourOrder, setUpdateFareTourOrder] = useState(false);
  const [updateFareInsuranceOrder, setUpdateFareInsuranceOrder] =
    useState(false);
  const [confirmIssuanceInsuranceOrder, setConfirmIssuanceInsuranceOrder] =
    useState(false);
  const [rebookInsuranceOrder, setRebookInsuranceOrder] = useState(false);
  const [loading, setLoading] = useState(false);
  const [packageModal, setPackageModal] = useState({
    cancel: false,
    pay: false,
    detail: false,
  });
  const [esimModal, setEsimModal] = useState({
    cancel: false,
    detail: false,
  });
  const { ticketType } = useSelector((state) => state.order);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open) {
        setTimeout(() => {
          setOpen(false);
        }, 400);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const menu = () => {
    let menus = ["Cancel order", "Open order", "Refund"];
    return menus;
  };

  const MenuType = ({ mobile }) => {
    switch (ticketType) {
      case "Flights":
        return <FlightMenu og={og} mobile={mobile} />;
      case configurations.stayKeyword:
        return (
          <StayMenu
            order={og}
            {...{ mobile }}
            setCancelHotelAwaitingBooking={setCancelHotelAwaitingBooking}
            setModifyHotelOrder={setModifyHotelOrder}
            setCancelHotelOrder={setCancelHotelOrder}
            setCancelPendingHotelOrder={setCancelPendingHotelOrder}
            setHotelPriceDetailModal={setHotelPriceDetailModal}
            setViewHotelOrder={setViewHotelOrder}
            setPayHotelOrder={setPayHotelOrder}
            setUpdateFareHotelOrder={setUpdateFareHotelOrder}
            setLoading={setLoading}
          />
        );
      case configurations.tourKeyword:
        return (
          <TourMenu
            order={og}
            {...{ mobile }}
            setViewTourOrder={setViewTourOrder}
            setCancelPendingTourOrder={setCancelPendingTourOrder}
            setPayTourOrder={setPayTourOrder}
            setUpdateFareTourOrder={setUpdateFareTourOrder}
            setLoading={setLoading}
          />
        );
      case configurations.insuranceKeyword:
        return (
          <InsuranceMenu
            order={og}
            {...{ mobile }}
            setCancelInsuranceOrder={setCancelInsuranceOrder}
            setViewInsuranceOrder={setViewInsuranceOrder}
            setCancelPendingInsuranceOrder={setCancelPendingInsuranceOrder}
            setPayInsuranceOrder={setPayInsuranceOrder}
            setUpdateFareInsuranceOrder={setUpdateFareInsuranceOrder}
            setConfirmIssuanceInsuranceOrder={setConfirmIssuanceInsuranceOrder}
            setRebookInsuranceOrder={setRebookInsuranceOrder}
            setLoading={setLoading}
          />
        );
      case configurations.services.package.value:
        return (
          <PackageMenu
            order={og}
            {...{ mobile }}
            setCancel={(val) =>
              setPackageModal({ ...packageModal, cancel: val })
            }
            setPay={(val) => setPackageModal({ ...packageModal, pay: val })}
            setDetail={(val) =>
              setPackageModal({ ...packageModal, detail: val })
            }
            setUpdateFareInsuranceOrder={setUpdateFareInsuranceOrder}
            // setInsuranceInvoice={setInsuranceInvoice}
          />
        );
      case configurations.services.esim.value:
        return (
          <EsimMenu
            order={og}
            {...{ mobile }}
            setCancel={(val) => setEsimModal({ ...esimModal, cancel: val })}
            setDetail={(val) => setEsimModal({ ...esimModal, detail: val })}
          />
        );
      default:
        <div className="absolute py-2 flex flex-col bg-white rounded-md right-6 top-4 shadow-md min-w-[200px]">
          {menu()?.map((item, index) => (
            <div key={index}>{item}</div>
          ))}
        </div>;
    }
  };

  return (
    <>
      {ticketType === configurations.stayKeyword && (
        <>
          <AccommodationOrderDetailsModal
            open={viewHotelOrder}
            booking={og}
            setOpen={setViewHotelOrder}
          />
          <ModifyHotelBookingModal
            open={modifyHotelOrder}
            booking={og}
            setOpen={setModifyHotelOrder}
          />
          <CancelAccommodationBookingModal
            open={cancelHotelOrder}
            booking={og}
            setOpen={setCancelHotelOrder}
          />
          <CancelAccommodationAwaitingBookingModal
            open={cancelHotelAwaitingBooking}
            booking={og}
            setOpen={setCancelHotelAwaitingBooking}
          />
          <CancelPendingAccommodationBookingModal
            open={cancelPendingHotelOrder}
            booking={og}
            setOpen={setCancelPendingHotelOrder}
          />
          <PayAccommodationBookingModal
            open={payHotelOrder}
            booking={og}
            setOpen={setPayHotelOrder}
          />
          <AccommodationOrderPriceDetailModal
            open={hotelPriceDetailModal}
            booking={og}
            setOpen={setHotelPriceDetailModal}
          />
          <UpdateFareAccommodationBookingModal
            open={updateFareHotelOrder}
            booking={og}
            setOpen={setUpdateFareHotelOrder}
          />
        </>
      )}
      {ticketType === configurations.tourKeyword && (
        <>
          <TourOrderDetailModal
            open={viewTourOrder}
            booking={og}
            setOpen={setViewTourOrder}
          />
          <CancelPendingTourBookingModal
            open={cancelPendingTourOrder}
            booking={og}
            setOpen={setCancelPendingTourOrder}
          />
          <PayTourBookingModal
            open={payTourOrder}
            booking={og}
            setOpen={setPayTourOrder}
          />
          <UpdateFareTourBookingModal
            open={updateFareTourOrder}
            booking={og}
            setOpen={setUpdateFareTourOrder}
          />
        </>
      )}
      {ticketType === configurations.services.package.value && (
        <>
          <CancelPackageModal
            open={packageModal.cancel}
            setOpen={(val) => setPackageModal({ ...packageModal, cancel: val })}
            booking={og}
          />
          <PayPackageBookingModal
            open={packageModal.pay}
            setOpen={(val) => setPackageModal({ ...packageModal, pay: val })}
            booking={og}
          />
          <PackageOrderDetailsModal
            open={packageModal.detail}
            setOpen={(val) => setPackageModal({ ...packageModal, detail: val })}
            booking={og}
          />
        </>
      )}
      {ticketType === configurations.services.esim.value && (
        <>
          <CancelEsimBookingModal
            open={esimModal.cancel}
            setOpen={(val) => setEsimModal({ ...esimModal, cancel: val })}
            booking={og}
            onSuccess={reload}
          />
          <EsimOrderDetailsModal
            open={esimModal.detail}
            setOpen={(val) => setEsimModal({ ...esimModal, detail: val })}
            booking={og}
          />
        </>
      )}
      {ticketType === configurations.insuranceKeyword && (
        <>
          <CancelInsuranceBookingModal
            open={cancelInsuranceOrder}
            booking={og}
            setOpen={setCancelInsuranceOrder}
            noSave
          />
          <CancelPendingInsuranceBookingModal
            open={cancelPendingInsuranceOrder}
            booking={og}
            setOpen={setCancelPendingInsuranceOrder}
            noSave
          />
          <InsuranceOrderDetailsModal
            open={viewInsuranceOrder}
            booking={og}
            setOpen={setViewInsuranceOrder}
            noSave
          />
          <PayInsuranceBookingModal
            open={payInsuranceOrder}
            booking={og}
            setOpen={setPayInsuranceOrder}
          />
          <UpdateFareInsuranceBookingModal
            open={updateFareInsuranceOrder}
            booking={og}
            setOpen={setUpdateFareInsuranceOrder}
          />
          <ConfirmInsuranceIssuanceModal
            open={confirmIssuanceInsuranceOrder}
            booking={og}
            setOpen={setConfirmIssuanceInsuranceOrder}
          />
          <RebookInsuranceBookingModal
            open={rebookInsuranceOrder}
            booking={og}
            setOpen={setRebookInsuranceOrder}
            onSuccess={reload}
          />
        </>
      )}
      <button
        className="cursor-pointer p-2 relative "
        disabled={loading}
        onClick={() => setOpen(true)}
      >
        {loading ? (
          <div className="primaryLoader"></div>
        ) : (
          <img
            src="/IconMore.svg"
            alt=""
            className="h-5 object-contain relative"
          />
        )}

        <SM className="">{open && <MenuType />}</SM>
        <SM lt>
          <SwipeableDrawer
            anchor="bottom"
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            SlideProps={{ className: "max-h-[50vh]" }}
          >
            <div className="flex flex-col h-full flex-1 gap-2 relative">
              <div
                className="flex gap-4 justify-between items-center shadow p-4"
                onClick={() => setOpen(false)}
              >
                <div className="flex items-center gap-2">
                  <Icon icon="mingcute:left-line" /> Order Menus
                </div>
                <button>
                  <Icon icon="mdi:close" />
                </button>
              </div>
              <div className="overflow-y-auto">
                <MenuType mobile />
              </div>
            </div>
          </SwipeableDrawer>
        </SM>
      </button>
    </>
  );
};

export default OrderMenu;
// Order menu
